'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

var _scrollIntoViewIfNeeded = require('../../helpers/scrollIntoViewIfNeeded');

var _utils = require('../../../api/actions/Db/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  TreeItem: {
    displayName: 'TreeItem'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/TreeItem/TreeItem.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
} // eslint-disable-line camelcase


// const frindlyName = name => name.replace(/\?/g, '').replace(/\ /g, '-');
//const frindlyName = name => name.replace(/\?/g, '');

var TreeItem = _wrapComponent('TreeItem')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(TreeItem, _Component);

  function TreeItem() {
    (0, _classCallCheck3.default)(this, TreeItem);
    return (0, _possibleConstructorReturn3.default)(this, (TreeItem.__proto__ || (0, _getPrototypeOf2.default)(TreeItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(TreeItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          parentItem = _props.parentItem,
          active = _props.active,
          renderRaw = _props.renderRaw,
          className = _props.className,
          children = _props.children,
          _onClick = _props.onClick,
          prefix = _props.prefix,
          position = _props.position;

      var prefixElem = prefix != null && prefix != '' ? _react3.default.createElement(
        'em',
        null,
        prefix,
        ' '
      ) : null; //eslint-disable-line
      // const styles = require('./DocList.scss');
      var targetRoute = parentItem ? '/' + parentItem.id + '/' + (0, _utils.frindlyName)(parentItem.name) + '/' + item.id + '/' + (0, _utils.frindlyName)(item.name) : '/' + item.id + '/' + (0, _utils.frindlyName)(item.name);

      // const itemType = null; /*item.scheme ? 'http://schema.org/ListItem': null;*/
      // const itemScope = itemType ? true : null;
      // const itemProp =  itemType ? 'itemListElement' : null;
      // const itemProp2 =  itemType ? 'item' : null;
      // const propName = itemType ? 'name' : null;
      // const metaOrder = itemType ? <meta itemProp="position" content={position} /> : null;
      // const metaType = itemType ? <meta itemProp="itemType" content={item.scheme} /> : null;
      //const metaUrl = itemType ? <meta itemProp="url" content={targetRoute} /> : null;
      var content = children || item.name;
      var raw = _onClick ? _react3.default.createElement(
        _reactRouter.Link,
        { to: targetRoute, onClick: function onClick() {
            return _onClick(item, parentItem, active);
          } },
        prefixElem,
        content
      ) : _react3.default.createElement(
        _reactRouter.Link,
        { to: targetRoute },
        prefixElem,
        content
      );

      if (renderRaw) return raw;
      if (active) {
        return _react3.default.createElement(
          'li',
          {
            ref: function ref(elem) {
              if (elem != null) {
                // eslint-disable-line eqeqeq
                (0, _scrollIntoViewIfNeeded.createPolyfil_ScrollIntoViewIfNeeded)();
                elem.scrollIntoViewIfNeeded();
              }
            },
            className: 'active treeItem list-group-item ' + (className || '') },
          raw
        );
      }
      return _react3.default.createElement(
        'li',
        { className: 'treeItem list-group-item ' + (className || '') },
        raw
      );
    }
  }]);
  return TreeItem;
}(_react2.Component), _class.propTypes = {
  item: _react2.PropTypes.object,
  position: _react2.PropTypes.number.isRequired,
  active: _react2.PropTypes.bool,
  prefix: _react2.PropTypes.string,
  onClick: _react2.PropTypes.func,
  parentItem: _react2.PropTypes.object,
  renderRaw: _react2.PropTypes.bool,
  className: _react2.PropTypes.string,
  children: _react2.PropTypes.oneOfType([_react2.PropTypes.arrayOf(_react3.default.PropTypes.node), _react2.PropTypes.node])

  // load: PropTypes.func.isRequired
}, _temp));

exports.default = TreeItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TreeItem/TreeItem.js
// module id = 1198
// module chunks = 0